import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LoaderButton',
  props: {
  size: {
    type: String as () => 'small',
    required: false,
    default: () => 'small',
  },
  themeColor: {
    type: String as () =>
      | 'primary'
      | 'primary-light'
      | 'secondary'
      | 'tertiary'
      | 'info'
      | 'info-light'
      | 'success'
      | 'warning'
      | 'error',
    required: false,
    default: () => 'primary',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(`loader loader__spinner loader__spinner--${__props.size} loader__spinner--${__props.themeColor}`)
  }, null, 2))
}
}

})